<template>
  <ContentWrap>
    <el-alert
      class="mb-12px"
      type="info"
      :closable="false"
      show-icon
      title="入企申请正常由企业管理员在小程序「个人资料 → 员工审核」中审批。本页用于其失联时的平台代审：代审会记录为「平台代审」，通过后申请人即绑定为该企业的在职员工。"
    />
    <el-form :inline="true" :model="query" class="-mb-15px">
      <el-form-item label="企业名称">
        <el-input
          v-model="query.companyName"
          clearable
          placeholder="模糊搜索（含未入驻的占位申请）"
          style="width: 220px"
          @keyup.enter="search"
        />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable placeholder="全部" style="width: 140px">
          <el-option
            v-for="dict in getIntDictOptions(DICT_TYPE.BOSSCIRCLE_COMPANY_JOIN_APPLY_STATUS)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="审核人类型">
        <el-select v-model="query.auditSource" clearable placeholder="全部" style="width: 140px">
          <el-option
            v-for="dict in getStrDictOptions(DICT_TYPE.BOSSCIRCLE_AUDIT_SOURCE)"
            :key="dict.value"
            :label="dict.label"
            :value="dict.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">
          <Icon class="mr-5px" icon="ep:search" />搜索
        </el-button>
        <el-button @click="reset">
          <Icon class="mr-5px" icon="ep:refresh" />重置
        </el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list" stripe>
      <el-table-column label="申请人" min-width="150">
        <template #default="{ row }">
          <div class="font-500">{{ row.userName || row.userId }}</div>
          <div class="text-12px text-#909399">{{ row.userPosition || '未填职务' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="申请企业" min-width="180" show-overflow-tooltip>
        <template #default="{ row }">
          {{ row.companyName }}
          <el-tag v-if="!row.companyId" class="ml-5px" size="small" type="info">未入驻</el-tag>
          <el-tag v-else-if="row.companyStatus === 1" class="ml-5px" size="small" type="danger">
            已停用
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="reason" label="申请理由" min-width="160" show-overflow-tooltip>
        <template #default="{ row }">{{ row.reason || '-' }}</template>
      </el-table-column>
      <el-table-column label="状态" width="110">
        <template #default="{ row }">
          <dict-tag :type="DICT_TYPE.BOSSCIRCLE_COMPANY_JOIN_APPLY_STATUS" :value="row.status" />
        </template>
      </el-table-column>
      <el-table-column label="应审核人" width="130">
        <template #default="{ row }">
          <span v-if="row.ownerName">{{ row.ownerName }}</span>
          <span v-else-if="!row.companyId" class="text-12px text-#e6a23c">无人可审（待入驻）</span>
          <span v-else class="text-12px text-#909399">-</span>
        </template>
      </el-table-column>
      <el-table-column label="审核人" width="150">
        <template #default="{ row }">
          <template v-if="row.auditTime">
            <div>{{ row.auditUserName || row.auditUserId || '-' }}</div>
            <dict-tag :type="DICT_TYPE.BOSSCIRCLE_AUDIT_SOURCE" :value="row.auditSource" />
          </template>
          <span v-else class="text-12px text-#909399">未审核</span>
        </template>
      </el-table-column>
      <el-table-column prop="auditRemark" label="审核意见" min-width="140" show-overflow-tooltip>
        <template #default="{ row }">{{ row.auditRemark || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createTime" label="申请时间" width="170" :formatter="dateFormatter" />
      <el-table-column label="操作" width="170" fixed="right">
        <template #default="{ row }">
          <template v-if="row.status === 0 || row.status === 3">
            <el-button
              v-hasPermi="['bosscircle:company-join-apply:audit']"
              link
              type="success"
              @click="openAudit(row, 1)"
            >
              代审通过
            </el-button>
            <el-button
              v-hasPermi="['bosscircle:company-join-apply:audit']"
              link
              type="danger"
              @click="openAudit(row, 2)"
            >
              代审驳回
            </el-button>
          </template>
          <el-button link type="primary" @click="openTrace(row)">轨迹</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="auditVisible" :title="auditTitle" width="560px">
    <el-form ref="auditFormRef" :model="auditForm" :rules="auditRules" label-width="110px">
      <el-form-item label="申请人">{{ current?.userName }}</el-form-item>
      <el-form-item label="申请企业">{{ current?.companyName }}</el-form-item>
      <el-form-item label="申请理由">
        <span class="text-13px text-#606266">{{ current?.reason || '未填写' }}</span>
      </el-form-item>
      <el-form-item label="审核结果" prop="auditStatus">
        <el-radio-group v-model="auditForm.auditStatus">
          <el-radio :value="1">通过（绑定为该企业在职员工）</el-radio>
          <el-radio :value="2">驳回</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        v-if="auditForm.auditStatus === 1 && !current?.companyId"
        label="关联企业"
        prop="companyId"
      >
        <el-select
          v-model="auditForm.companyId"
          filterable
          remote
          reserve-keyword
          placeholder="输入关键字搜索已入驻企业"
          :remote-method="searchCompanies"
          :loading="companyLoading"
          style="width: 100%"
        >
          <el-option
            v-for="item in companyOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id!"
          />
        </el-select>
        <div class="mt-4px text-12px text-#e6a23c">
          该企业尚未入驻，通过前必须关联一家已入驻企业。
        </div>
      </el-form-item>
      <el-form-item label="审核意见" prop="auditRemark">
        <el-input
          v-model="auditForm.auditRemark"
          type="textarea"
          :rows="3"
          placeholder="驳回必填，将展示给申请人"
        />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="auditVisible = false">取 消</el-button>
      <el-button :loading="submitting" type="primary" @click="submitAudit">
        确认平台代审
      </el-button>
    </template>
  </Dialog>

  <el-drawer v-model="traceVisible" title="企业审核轨迹" size="62%">
    <div class="mb-12px text-13px text-#909399">
      {{ traceCompany || '-' }} · 按时间倒序，含入驻审核、入企审核与成员变更
    </div>
    <el-table v-loading="traceLoading" :data="traceList" stripe>
      <el-table-column label="环节" width="130">
        <template #default="{ row }">
          <dict-tag :type="DICT_TYPE.BOSSCIRCLE_AUDIT_TRACE_BIZ_TYPE" :value="row.bizType" />
        </template>
      </el-table-column>
      <el-table-column label="当事人" min-width="120">
        <template #default="{ row }">{{ row.actorName || row.actorUserId || '-' }}</template>
      </el-table-column>
      <el-table-column label="结果" width="110">
        <template #default="{ row }">
          <dict-tag :type="row.statusDictType" :value="row.status ?? ''" />
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="说明" min-width="160" show-overflow-tooltip>
        <template #default="{ row }">{{ row.remark || '-' }}</template>
      </el-table-column>
      <el-table-column label="操作人" width="140">
        <template #default="{ row }">
          <template v-if="row.operatorName || row.operatorUserId">
            <div>{{ row.operatorName || row.operatorUserId }}</div>
            <dict-tag :type="DICT_TYPE.BOSSCIRCLE_AUDIT_SOURCE" :value="row.operatorSource ?? ''" />
          </template>
          <span v-else class="text-12px text-#909399">-</span>
        </template>
      </el-table-column>
      <el-table-column prop="bizTime" label="时间" width="170" :formatter="dateFormatter" />
    </el-table>
    <el-empty v-if="!traceLoading && !traceList.length" description="暂无审核记录" />
  </el-drawer>
</template>

<script setup lang="ts">
import { dateFormatter } from '@/utils/formatTime'
import { DICT_TYPE, getIntDictOptions, getStrDictOptions } from '@/utils/dict'
import { getCompanyAccountPage } from '@/api/business/companyAccount'
import * as Api from '@/api/business/companyJoinApply'
import type { FormInstance, FormRules } from 'element-plus'

defineOptions({ name: 'BossCircleCompanyJoinApply' })

const message = useMessage()
const route = useRoute()

const loading = ref(false)
const list = ref<Api.CompanyJoinApplyVO[]>([])
const total = ref(0)
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  companyName: undefined as string | undefined,
  status: (route.query.status === undefined ? undefined : Number(route.query.status)) as
    | number
    | undefined,
  auditSource: undefined as string | undefined
})

const load = async () => {
  loading.value = true
  try {
    const data = await Api.getCompanyJoinApplyPage({
      pageNo: query.pageNo,
      pageSize: query.pageSize,
      companyName: query.companyName || undefined,
      status: query.status,
      auditSource: query.auditSource || undefined
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}

const search = () => {
  query.pageNo = 1
  load()
}

const reset = () => {
  query.companyName = undefined
  query.status = undefined
  query.auditSource = undefined
  search()
}

// ==================== 平台代审 ====================
const auditVisible = ref(false)
const auditFormRef = ref<FormInstance>()
const submitting = ref(false)
const current = ref<Api.CompanyJoinApplyVO>()
const auditForm = reactive({
  auditStatus: 1 as 1 | 2,
  auditRemark: '',
  companyId: undefined as string | undefined
})
const auditTitle = computed(
  () => (auditForm.auditStatus === 1 ? '平台代审：通过入企申请' : '平台代审：驳回入企申请')
)
const auditRules = computed(
  () =>
    ({
      auditRemark:
        auditForm.auditStatus === 2
          ? [{ required: true, message: '驳回时必须填写原因', trigger: 'blur' }]
          : [],
      companyId:
        auditForm.auditStatus === 1 && !current.value?.companyId
          ? [{ required: true, message: '请选择一家已入驻企业', trigger: 'change' }]
          : []
    }) as FormRules
)

const companyOptions = ref<{ id?: string; name: string }[]>([])
const companyLoading = ref(false)
const searchCompanies = async (keyword: string) => {
  companyLoading.value = true
  try {
    const data = await getCompanyAccountPage({
      pageNo: 1,
      pageSize: 30,
      name: keyword || undefined,
      status: 0
    })
    companyOptions.value = (data.list || []).map((item: any) => ({
      id: String(item.id),
      name: item.name
    }))
  } finally {
    companyLoading.value = false
  }
}

const openAudit = (row: Api.CompanyJoinApplyVO, auditStatus: 1 | 2) => {
  current.value = row
  auditForm.auditStatus = auditStatus
  auditForm.auditRemark = ''
  auditForm.companyId = undefined
  auditVisible.value = true
  nextTick(() => auditFormRef.value?.clearValidate())
  if (auditStatus === 1 && !row.companyId) {
    searchCompanies('')
  }
}

const submitAudit = async () => {
  await auditFormRef.value?.validate()
  await message.confirm(
    `平台代审${auditForm.auditStatus === 1 ? '通过' : '驳回'}后，审核人将记为「平台代审」，${
      auditForm.auditStatus === 1 ? '申请人立即绑定为企业员工' : '申请人可重新提交申请'
    }。确认继续？`
  )
  submitting.value = true
  try {
    await Api.auditCompanyJoinApply({
      id: current.value!.id!,
      auditStatus: auditForm.auditStatus,
      auditRemark: auditForm.auditRemark.trim() || undefined,
      companyId: auditForm.companyId
    })
    message.success(auditForm.auditStatus === 1 ? '已代审通过并绑定员工' : '已驳回')
    auditVisible.value = false
    await load()
  } finally {
    submitting.value = false
  }
}

// ==================== 审核轨迹 ====================
const traceVisible = ref(false)
const traceLoading = ref(false)
const traceList = ref<Api.CompanyAuditTraceVO[]>([])
const traceCompany = ref('')

const openTrace = async (row: Api.CompanyJoinApplyVO) => {
  traceCompany.value = row.companyName || ''
  traceList.value = []
  traceVisible.value = true
  traceLoading.value = true
  try {
    traceList.value =
      (await Api.getCompanyAuditTrace({
        companyId: row.companyId,
        companyName: row.companyName
      })) || []
  } finally {
    traceLoading.value = false
  }
}

onMounted(load)
</script>
